export type TipoCadastroRota = 'rota' | 'horario' | 'ponto' | 'despesa';
export type RegistroRota = Record<string, string | number | boolean | null>;
export const diasSemanaRota = [
  { nome: 'segunda', rotulo: 'Segunda-feira' },
  { nome: 'terca', rotulo: 'Terça-feira' },
  { nome: 'quarta', rotulo: 'Quarta-feira' },
  { nome: 'quinta', rotulo: 'Quinta-feira' },
  { nome: 'sexta', rotulo: 'Sexta-feira' },
  { nome: 'sabado', rotulo: 'Sábado' },
  { nome: 'domingo', rotulo: 'Domingo' },
];
export type CoordenadaRota = [number, number];

export function proximaOrdemPonto(pontos: RegistroRota[]): number {
  return pontos.reduce((maior, ponto) => Math.max(maior, Number(ponto.ordem) || 0), 0) + 1;
}

export function pontosOrdenadosComCoordenadas(pontos: RegistroRota[]): RegistroRota[] {
  return pontos
    .filter((ponto) => {
      if (ponto.latitude == null || ponto.longitude == null) return false;
      const latitude = Number(ponto.latitude);
      const longitude = Number(ponto.longitude);
      return (
        ponto.latitude !== '' &&
        ponto.longitude !== '' &&
        Number.isFinite(latitude) &&
        Number.isFinite(longitude) &&
        Math.abs(latitude) <= 90 &&
        Math.abs(longitude) <= 180 &&
        (latitude !== 0 || longitude !== 0)
      );
    })
    .slice()
    .sort(
      (a, b) =>
        Number(a.ordem) - Number(b.ordem) || Number(a.traRotaPontoId) - Number(b.traRotaPontoId),
    );
}
export interface CampoRota {
  nome: string;
  rotulo: string;
  tipo: 'text' | 'textarea' | 'number' | 'time' | 'date' | 'lista';
  max?: number;
  min?: number;
  passo?: string;
  lista?: string;
  obrigatorio?: boolean;
}
export const cadastrosRota: Record<
  TipoCadastroRota,
  {
    titulo: string;
    singular: string;
    nome: string;
    endpoint: string;
    id: string;
    ordenacao: string;
    campos: CampoRota[];
  }
> = {
  rota: {
    titulo: 'Rotas',
    singular: 'Rota',
    nome: 'trarota',
    endpoint: 'TraRota',
    id: 'traRotaId',
    ordenacao: 'inicio ASC',
    campos: [
      { nome: 'observacao', rotulo: 'Descrição/Objetivo', tipo: 'textarea', max: 1000 },
      { nome: 'tipoServico', rotulo: 'Tipo de Serviço', tipo: 'text', max: 30 },
      { nome: 'inicio', rotulo: 'Início', tipo: 'text', max: 30, obrigatorio: true },
      { nome: 'final', rotulo: 'Final', tipo: 'text', max: 30, obrigatorio: true },
      {
        nome: 'fornecedorId',
        rotulo: 'Empresa Contratada',
        tipo: 'lista',
        lista: 'fornecedores',
        obrigatorio: true,
      },
      { nome: 'quilometragem', rotulo: 'Distância em km', tipo: 'number', passo: '0.1', min: 0 },
    ],
  },
  horario: {
    titulo: 'Horários',
    singular: 'Horário',
    nome: 'trarotahorario',
    endpoint: 'TraRotaHorario',
    id: 'traRotaHorarioId',
    ordenacao: 'horaInicio ASC',
    campos: [
      { nome: 'horario', rotulo: 'Hora Inicial', tipo: 'time', obrigatorio: true },
      { nome: 'direcao', rotulo: 'Direção', tipo: 'lista', lista: 'direcoes', obrigatorio: true },
      {
        nome: 'motoristaId',
        rotulo: 'Motorista',
        tipo: 'lista',
        lista: 'motoristas',
        obrigatorio: true,
      },
      { nome: 'auxiliarId', rotulo: 'Auxiliar', tipo: 'lista', lista: 'auxiliares' },
      {
        nome: 'traVeiculoId',
        rotulo: 'Veículo',
        tipo: 'lista',
        lista: 'veiculos',
        obrigatorio: true,
      },
    ],
  },
  ponto: {
    titulo: 'Pontos',
    singular: 'Ponto',
    nome: 'trarotaponto',
    endpoint: 'TraRotaPonto',
    id: 'traRotaPontoId',
    ordenacao: 'ordem ASC',
    campos: [
      {
        nome: 'ordem',
        rotulo: 'Ordem',
        tipo: 'number',
        min: 1,
        max: 32767,
        passo: '1',
        obrigatorio: true,
      },
      { nome: 'descricao', rotulo: 'Ponto', tipo: 'text', max: 50, obrigatorio: true },
      {
        nome: 'tempoEstimado',
        rotulo: 'Tempo estimado até o ponto (min)',
        tipo: 'number',
        min: 0,
        max: 2147483647,
        passo: '1',
      },
      { nome: 'latitude', rotulo: 'Latitude', tipo: 'number', min: -90, max: 90, passo: 'any' },
      { nome: 'longitude', rotulo: 'Longitude', tipo: 'number', min: -180, max: 180, passo: 'any' },
    ],
  },
  despesa: {
    titulo: 'Despesas',
    singular: 'Despesa',
    nome: 'trarotadespesa',
    endpoint: 'TraRotaDespesa',
    id: 'traRotaDespesaId',
    ordenacao: 'data DESC',
    campos: [
      { nome: 'data', rotulo: 'Data', tipo: 'date', obrigatorio: true },
      {
        nome: 'tipoDespesa',
        rotulo: 'Tipo de Despesa',
        tipo: 'lista',
        lista: 'tiposDespesa',
        obrigatorio: true,
      },
      { nome: 'descricao', rotulo: 'Descrição', tipo: 'text', max: 50 },
      {
        nome: 'valor',
        rotulo: 'Valor',
        tipo: 'number',
        min: 0.01,
        passo: '0.01',
        obrigatorio: true,
      },
    ],
  },
};
export const direcoesRota = [
  { valor: 0, texto: 'Ida' },
  { valor: 1, texto: 'Volta' },
];
export const tiposDespesaRota = [
  { valor: 1, texto: 'Contrato' },
  { valor: 2, texto: 'Pessoal' },
  { valor: 3, texto: 'Pedágio' },
  { valor: 99, texto: 'Diversos' },
];
export function tipoCadastroRota(value: unknown): TipoCadastroRota {
  return value === 'horario' || value === 'ponto' || value === 'despesa' ? value : 'rota';
}
export function horaDecimalParaTexto(value: unknown): string {
  const numero = Number(value ?? 0);
  if (!Number.isFinite(numero) || numero < 0 || numero >= 24) return '';
  const minutos = Math.round(numero * 60);
  return `${String(Math.floor(minutos / 60)).padStart(2, '0')}:${String(minutos % 60).padStart(2, '0')}`;
}
export function horaTextoParaDecimal(value: unknown): number {
  if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(String(value))) throw new Error('Hora Inicial inválida.');
  const [hora, minuto] = String(value).split(':').map(Number);
  return hora + minuto / 60;
}
export function novoRegistroRota(tipo: TipoCadastroRota, traRotaId = 0): RegistroRota {
  if (tipo === 'rota')
    return {
      traRotaId: 0,
      tipoServico: 'Transporte Escolar',
      inicio: '',
      final: '',
      observacao: '',
      fornecedorId: null,
      rural: 1,
      quilometragem: 0,
      distancia: null,
      tipoVeiculo: null,
    };
  if (tipo === 'horario')
    return {
      traRotaHorarioId: 0,
      ...Object.fromEntries(diasSemanaRota.map((dia) => [dia.nome, false])),
      traRotaId,
      horario: '00:00',
      horaInicio: 0,
      direcao: 0,
      motoristaId: null,
      auxiliarId: null,
      traVeiculoId: null,
    };
  if (tipo === 'ponto')
    return {
      traRotaPontoId: 0,
      tempoEstimado: 0,
      traRotaId,
      ordem: 1,
      descricao: '',
      latitude: 0,
      longitude: 0,
      tipoServico: null,
    };
  const hoje = new Date();
  const data = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${String(hoje.getDate()).padStart(2, '0')}`;
  return { traRotaDespesaId: 0, traRotaId, data, tipoDespesa: 99, descricao: '', valor: 0 };
}
export function normalizarRegistroRota(tipo: TipoCadastroRota, data: RegistroRota): RegistroRota {
  const model = { ...novoRegistroRota(tipo), ...data };
  // Defaults de NOVO não devem substituir zeros omitidos pelo serializer ao editar.
  if (tipo === 'rota') {
    model.rural = Number(data.rural ?? 0);
    model.fornecedorId = Number(data.fornecedorId) || null;
  }
  if (tipo === 'horario') {
    for (const dia of diasSemanaRota)
      model[dia.nome] = data[dia.nome] === true || data[dia.nome] === 1;
    model.horario = horaDecimalParaTexto(data.horaInicio);
    model.auxiliarId = Number(data.auxiliarId) || null;
  }
  if (tipo === 'despesa') model.data = String(data.data ?? '').substring(0, 10);
  return model;
}
